let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bRiD4")).then(() => parcelRequire('1TjIF'));